import { DataItem, formatCurrency, StatusContainer } from '@servicetitan/financing-utils-shared';
import ApprovedIllustration from '../../common/illustrations/checkmark-success.svg';
import { Card, Flex, Link } from '@servicetitan/anvil2';
import { ProviderLogo } from '@servicetitan/financing-provider-assets';
import { DecisionDataStore } from '../decision';
import { DeclinedWarningBox } from './DeclinedWarningBox';
import {
    useProviderConfig,
    useSecondLookIntegration,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';

interface ApprovedProps {
    onDeclinedLinkClick?: () => void;
}

export const Approved = ({ onDeclinedLinkClick }: ApprovedProps) => {
    const { decisionData } = DecisionDataStore.useStore();
    const providerConfig = useProviderConfig();
    const { secondLookProvider } = useSecondLookIntegration();
    const secondLookProviderName = useSecondLookProviderName();

    const hasDeclinedAction = providerConfig.declinedAccessLinkLabel && onDeclinedLinkClick;

    const declinedMessage = hasDeclinedAction ? (
        <>
            {providerConfig.declinedMessage ? `${providerConfig.declinedMessage} ` : null}
            However, you may still apply for financing with the{' '}
            <Link onClick={onDeclinedLinkClick}>{providerConfig.declinedAccessLinkLabel}</Link>.
        </>
    ) : undefined;

    return (
        <Flex direction="column" gap="6" alignItems="center">
            <DeclinedWarningBox message={declinedMessage} />
            <StatusContainer
                image={ApprovedIllustration}
                headline={`Your pre-qualification application was approved by ${secondLookProviderName}.`}
            >
                <Card style={{ width: '100%' }}>
                    <Flex
                        direction="row"
                        justifyContent="space-between"
                        gap="4"
                        style={{ width: '100%' }}
                    >
                        <DataItem
                            label="Provider"
                            text={
                                <Flex gap="1" alignItems="center">
                                    {secondLookProviderName}{' '}
                                    <ProviderLogo
                                        provider={secondLookProvider}
                                        height="24px"
                                        maxWidth="68px"
                                    />
                                </Flex>
                            }
                            style={{ flex: 1 }}
                        />
                        <DataItem
                            label="Loan Amount"
                            text={formatCurrency(decisionData?.approvedAmount ?? 0)}
                            style={{ flex: 1 }}
                        />
                        <DataItem
                            label="Credit Limit"
                            text={formatCurrency(decisionData?.maxCreditAmount ?? 0)}
                            style={{ flex: 1 }}
                        />
                    </Flex>
                </Card>
            </StatusContainer>
        </Flex>
    );
};
